import { render, staticRenderFns } from "./ItemRatePage.vue?vue&type=template&id=aaf89018&scoped=true&"
import script from "./ItemRatePage.vue?vue&type=script&lang=js&"
export * from "./ItemRatePage.vue?vue&type=script&lang=js&"
import style0 from "./ItemRatePage.vue?vue&type=style&index=0&id=aaf89018&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf89018",
  null
  
)

export default component.exports